import { FieldTypes } from './field-types'

export class DataTypesHelper {

  /**
   *
   * @param columnDefinition
   * @returns {boolean}
   */
  static isDocumentImage (columnDefinition) {
    if (columnDefinition.hasOwnProperty('Document.Field.Content') &&
      columnDefinition.hasOwnProperty('Document.Field.FileGUID') &&
      columnDefinition.hasOwnProperty('Document.Field.FileName') &&
      (columnDefinition.FieldType === FieldTypes.document) ||
      (columnDefinition.FieldType === FieldTypes.signature)) {
      return true
    }

    return false
  }
}
